import _ from 'lodash';
import { connect } from 'react-redux';

import { Header as PlatformHeader } from '@zapier/product-dev-platform';
import { Profile } from '@zapier/shared-entities';
import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import MaybeLoad from 'app/common/components/MaybeLoad';
import hocify from 'app/common/components/hocify';
import { Dispatch } from 'app/common/types';
import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

const mapStateToProps = state => {
  const isLoggedIn = Profile.selectors.all.isLoggedIn(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const user = isLoggedIn
    ? {
        name: Profile.selectors.normalizedName(currentProfile) || '',
        avatarUrl: Profile.selectors.gravatarUrl(currentProfile),
      }
    : null;

  return {
    isLoading: Profile.selectors.all.isLoadImpending(state),
    currentUrl: RouterSelectors.currentUrl(state) || '',
    user,
    /**
     * These links are hardcoded in https://github.com/zapier/zapier/blob/develop/packages/products/dev-platform/src/components/Header/Header.tsx#L29
     * We can't update them there yet because we share that component with the `developer-v3` copy on `zapier/zapier`.
     * We will be able to clean this up once we do the cut-off from `zapier/zapier` and our version of `developer-v3` is the source of truth.
     */
    navLinks: [
      {
        label: 'How to Build',
        href: `${PLATFORM_MARKETING_BASE_URL}/how-to-build`,
      },
      {
        label: 'Partner Program',
        href: `${PLATFORM_MARKETING_BASE_URL}/partner-program`,
      },
      {
        label: 'Documentation',
        href: 'https://platform.zapier.com/docs',
      },
      {
        label: 'Help',
        href: '/contact',
      },
    ],
    ctaLinks: [
      {
        label: 'My Integrations',
        href: '/',
      },
      {
        label: 'Zap Templates',
        href: `${ZAPIER_APP_BASE_URL}/developer/zap-templates/`,
      },
    ],
    userLinks: [
      {
        label: 'Settings',
        href: '/partner-settings',
      },
    ],
    logoUrl: PLATFORM_MARKETING_BASE_URL,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onLoad() {
    dispatch(Profile.actions.loadCollection());
  },
});

export default _.flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  hocify(MaybeLoad)
)(PlatformHeader);
